import React, { useContext, memo } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

import AuthContext from "common/store/AuthContext";
import StatusContext from "common/store/StatusContext";

import LoadingSpinner from "../atoms/LoadingSpinner";
import { ILLinkContainer } from "../atoms/ILLinkContainer";
import { Button } from "react-bootstrap";

type Props = {
  onHumbergerClick?: () => void;
  changePassword?: boolean;
};

export const Topbar = memo((props: Props) => {
  const { changePassword = true } = props;
  const navigation = useNavigate();
  const authCtx = useContext(AuthContext);
  const { isLoading, loadingMessage, isEditing } = useContext(StatusContext);

  const changeParkHandler = () => {
    authCtx.selectPark(null);
    navigation("/");
  };

  const changePasswordHandler = () => {
    navigation("/password");
  };

  const logoutHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    authCtx.logout();
    navigation("/");
  };

  return (
    <header>
      <SNavbar
        className="d-flex justify-content-between px-2"
        bg="primary"
        variant="dark"
        collapseOnSelect
      >
        <SLeftPart>
          {props.onHumbergerClick && (
            <SButton onClick={props.onHumbergerClick}>
              <i className="fas fa-bars" />
            </SButton>
          )}
          <ILLinkContainer to="/" className="navbar-brand ms-2">
            <div style={{ cursor: "pointer" }}>Information Landscape</div>
          </ILLinkContainer>
          <STitle> {authCtx.selectedPark?.parkName}</STitle>
          {isLoading && (
            <LoadingSpinner
              animation="border"
              variant="light"
              size="sm"
              className="my-0 mx-2"
              message={loadingMessage}
            />
          )}
        </SLeftPart>
        {authCtx.isLoggedIn && (
          <Nav>
            <NavDropdown
              title={<STitle>{`こんにちは、${authCtx.userName}さん`}</STitle>}
              disabled={isEditing}
            >
              <NavDropdown.Item className="text-primary" onClick={changeParkHandler}>
                <i className="fas fa-exchange-alt"></i> <span className="mx-2">公園変更 </span>
              </NavDropdown.Item>

              <SNavDropdownItem
                className="text-primary"
                onClick={changePasswordHandler}
                disabled={!changePassword}
              >
                <i className="fas fa-key"></i> <span className="mx-2">パスワード変更 </span>
              </SNavDropdownItem>

              <NavDropdown.Item className="text-primary" onClick={logoutHandler}>
                <i className="fas fa-sign-out-alt"></i> <span className="mx-2">ログアウト </span>
              </NavDropdown.Item>

              <SNavDropdownDivider />

              <NavDropdown.Item
                className="text-primary"
                href="./manual/インフォランドポータルマニュアル.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-book"></i> <span className="mx-2">マニュアル </span>
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        )}
      </SNavbar>
    </header>
  );
});

export default Topbar;

const SNavbar = styled(Navbar)`
  background-image: none !important;
  background-color: ${(props) => props.theme.color.title} !important;
  z-index: 1;
  flex-wrap: wrap;
`;

const SLeftPart = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
`;

const STitle = styled.span`
  color: white;
  @media screen and (max-width: 768px) {
    margin-left: 0.5rem;
  }
`;

const SButton = styled(Button)`
  background: transparent;
  color: ${(props) => props.theme.color.menuHeaderText};
  align-self: flex-end;
  margin-right: 0;
  border: none;
  &.btn-primary:hover {
    color: ${(props) => props.theme.color.menuHeaderText};
    background-image: none;
    border: none;
  }
`;

const SNavDropdownItem = styled(NavDropdown.Item)`
  &.disabled {
    color: ${(props) => props.theme.color.menuDisabled} !important;
  }
`;

const SNavDropdownDivider = styled(NavDropdown.Divider)`
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  color: ${(props) => props.theme.color.menuHeader};
`;
